import React, { useEffect, useState } from 'react';

import { colors, container } from '../theme';
import { navLinks, logoWhite } from '../data';

const pill = (extra) => ({
  borderRadius: 999,
  padding: '9px 18px',
  color: colors.ink,
  fontWeight: 600,
  textDecoration: 'none',
  ...extra,
});

// Fixed top nav. Gains a translucent blurred scrim once the page scrolls, and
// collapses to a hamburger + dropdown panel on small screens.
export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const apply = () => {
      setIsMobile(mq.matches);
      if (!mq.matches) setOpen(false);
    };
    apply();
    mq.addListener(apply);
    return () => mq.removeListener(apply);
  }, []);

  // The bar is opaque when scrolled OR when the mobile menu is open.
  const solid = scrolled || (isMobile && open);

  return (
    <nav
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        background: solid ? 'rgba(10,10,12,.92)' : 'transparent',
        backdropFilter: solid ? 'blur(14px)' : 'none',
        WebkitBackdropFilter: solid ? 'blur(14px)' : 'none',
        borderBottom: `1px solid ${solid ? 'rgba(255,255,255,.08)' : 'transparent'}`,
        transition: 'background .3s,border-color .3s',
      }}>
      <div
        style={{
          ...container,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: isMobile ? '18px 22px' : '24px 40px',
        }}>
        <a href="#top" onClick={() => setOpen(false)} style={{ display: 'flex' }}>
          <img src={logoWhite} alt="Lyfe" style={{ height: 22, display: 'block' }} />
        </a>

        {isMobile ? (
          <button
            type="button"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            style={{
              background: 'none',
              border: 'none',
              padding: 8,
              margin: -8,
              cursor: 'pointer',
              color: colors.ink,
              display: 'flex',
            }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              {open ? (
                <>
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </>
              ) : (
                <>
                  <line x1="3" y1="7" x2="21" y2="7" />
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="17" x2="21" y2="17" />
                </>
              )}
            </svg>
          </button>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 36, fontSize: 14 }}>
            {navLinks.map((l) => (
              <a key={l.href} className="lyfe-link" href={l.href}>
                {l.label}
              </a>
            ))}
            <a className="lyfe-btn" href="#venues" style={pill({ background: colors.bg, border: `1px solid ${colors.ink}` })}>
              For venues
            </a>
            <a className="lyfe-btn" href="#get" style={pill({ background: colors.orange })}>
              Get the app
            </a>
          </div>
        )}
      </div>

      {/* Mobile dropdown panel */}
      {isMobile && open && (
        <div
          style={{
            borderTop: '1px solid rgba(255,255,255,.08)',
            padding: '10px 22px 26px',
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}>
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              style={{ color: colors.muted, textDecoration: 'none', fontSize: 17, padding: '14px 0', borderBottom: '1px solid rgba(255,255,255,.06)' }}>
              {l.label}
            </a>
          ))}
          <a
            href="#venues"
            onClick={() => setOpen(false)}
            style={{ color: colors.muted, textDecoration: 'none', fontSize: 17, padding: '14px 0', borderBottom: '1px solid rgba(255,255,255,.06)' }}>
            For venues
          </a>
          <a
            href="#get"
            onClick={() => setOpen(false)}
            style={pill({ background: colors.orange, textAlign: 'center', padding: '15px 18px', marginTop: 18, fontSize: 15 })}>
            Get the app
          </a>
        </div>
      )}
    </nav>
  );
}
